import { render, staticRenderFns } from "./ReplyEmail.vue?vue&type=template&id=d20677d0"
import script from "./ReplyEmail.vue?vue&type=script&lang=js"
export * from "./ReplyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports